import type { AuctionCarPagination } from '@autobid/ui/types/Car'
import type { MaybeRef } from 'vue'
import { usePrefetchBarometerCar } from '@autobid/ui/composables/car/data/useBarometerCar'
import { usePrefetchDetailsCar } from '@autobid/ui/composables/car/data/useDetailsCar'
import { useCarPageInfo } from '@autobid/ui/composables/car/useCarPageInfo'
import { getIdFromSlug } from '@autobid/ui/utils/car/getIdFromSlug'
import { onMounted, ref, unref } from 'vue'

export function usePrefetchPagination(pagination: MaybeRef<AuctionCarPagination | undefined>) {
  const prefetchable = ref(false)
  const { pageType } = useCarPageInfo()
  const { prefetchBarometerCar } = usePrefetchBarometerCar()
  const { prefetchDetailsCar } = usePrefetchDetailsCar()

  const prefetch = async (type: 'next' | 'prev') => {
    if (!prefetchable.value)
      return

    const link
      = type === 'prev' ? unref(pagination)?.previous : unref(pagination)?.next

    if (!link) {
      return
    }

    const idOfCarToPrefetch = getIdFromSlug(link)

    return pageType.value === 'details'
      ? prefetchDetailsCar(idOfCarToPrefetch)
      : prefetchBarometerCar({
          type: 'item',
          carId: idOfCarToPrefetch,
        })
  }

  onMounted(() => {
    setTimeout(() => {
      prefetchable.value = true
    }, 200)
  })

  return {
    prefetch,
  }
}
